import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';

@Component({
	selector: 'app-tag',
	templateUrl: './tag.component.html',
	styleUrls: ['./tag.component.css'],
})
export class TagComponent extends ShowComponent {
	protected apiType = 'bag';
	protected apiUrlAdd = '/tag/';
	protected parentComponent = 'codebook/tag';
	parentLocationSet = [];
	codebook;
	isEmpty = false;
	protected itemsBeforeDataLoad = 2;

	protected pageTitleGenerate(): string {
		return `Słowniki -> 
			${this.codebook.name}
			 -> 
			${this.data.name}
			(ID: 
			${this.data.id}
			)`;
	}

	data = {
		id: null,
		name: null,
		tag: null,
	};

	protected loadBefore(): void {
		this.bag.get('/tag/', (result, error) => {
			this.parentLocationSet = result.results;
			this.loadData();
		});
		this.bag.get('/codebook/7/', (result, error) => {
			this.codebook = result;

			this.loadData();
		});
	}

	protected submitAfter(): void {
		this.router.navigate([this.parentComponent]);
	}

	checkFormBeforeSubmit() {
		if (this.isEmpty == true) {
			this.infobox.error('Uzupełnij poprawnie wszytkie pola!');
			return;
		}
		this.submit();
	}

	isEmptyCheck() {
		const singleChar = this.data.tag.split('');
		if (singleChar.find((item) => item == ' ') == undefined) {
			this.isEmpty = false;
		} else {
			this.isEmpty = true;
		}
	}

	protected getApiUrl(): string {
		return '/tag/' + this.data.id + '/';
	}
}
